import React, { useEffect, useState } from "react";
import { ShieldCheck, Wrench } from "lucide-react";
import { crm } from "@/lib/crm";

// Pays du visiteur SANS IP : fuseau horaire du navigateur, sinon région de la langue.
const TZ_COUNTRY = {
  "Europe/Brussels": "BE", "Europe/Paris": "FR", "Europe/Amsterdam": "NL",
  "Europe/Berlin": "DE", "Europe/Busingen": "DE", "Europe/Luxembourg": "LU",
  "Europe/Rome": "IT", "Europe/Madrid": "ES", "Atlantic/Canary": "ES",
  "Europe/Lisbon": "PT", "Europe/Warsaw": "PL", "Europe/Bucharest": "RO",
  "Europe/Vienna": "AT",
};
const CC = ["BE", "FR", "NL", "DE", "LU", "IT", "ES", "PT", "PL", "RO", "AT"];
function visitorCountry() {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (tz && TZ_COUNTRY[tz]) return TZ_COUNTRY[tz];
  } catch { /* noop */ }
  try {
    const m = (navigator.language || "").match(/[-_]([A-Za-z]{2})/);
    if (m && CC.includes(m[1].toUpperCase())) return m[1].toUpperCase();
  } catch { /* noop */ }
  return null;
}

// Récupère les partenaires assurance/garantie applicables à une fiche.
// Aucun bouton n'est rendu si rien d'actif (ou démo via ?apercu_partenaire).
export function useInsurancePartners(carId, vt) {
  const [partners, setPartners] = useState([]);
  useEffect(() => {
    if (!carId) { setPartners([]); return; }
    const apercu = new URLSearchParams(window.location.search).get("apercu_partenaire");
    const pays = new URLSearchParams(window.location.search).get("pays_visiteur") || visitorCountry();
    const qs = [];
    if (vt) qs.push(`vt=${encodeURIComponent(vt)}`);
    if (apercu) qs.push(`apercu_partenaire=${encodeURIComponent(apercu)}`);
    if (pays) qs.push(`pays_visiteur=${encodeURIComponent(pays)}`);
    let alive = true;
    crm(`/placements/for-car/${encodeURIComponent(carId)}${qs.length ? `?${qs.join("&")}` : ""}`)
      .then((d) => { if (alive) setPartners(Array.isArray(d) ? d : []); })
      .catch(() => { if (alive) setPartners([]); });
    return () => { alive = false; };
  }, [carId, vt]);
  return partners;
}

const LABELS = {
  insurance_auto: "Demander un devis assurance",
  insurance_moto: "Demander un devis assurance",
  warranty: "Garantie panne mécanique",
};
const ICONS = { warranty: Wrench };

export default function InsurancePartnerButton({ partner, lang = "fr", className = "" }) {
  if (!partner || !partner.href) return null;
  const Icon = ICONS[partner.category] || ShieldCheck;
  const href = `${partner.href}${partner.href.includes("?") ? "&" : "?"}lang=${encodeURIComponent(lang)}`;
  return (
    <a
      data-testid={`insurance-partner-${partner.category}`}
      href={href}
      target="_blank"
      rel="sponsored noopener"
      className={`flex min-h-[44px] flex-col items-center justify-center gap-0.5 rounded-xl border border-[#C9D2DC]/40 bg-gradient-to-b from-[#13304F] to-[#0F2540] px-2 py-2.5 text-center text-xs font-bold text-white transition hover:from-[#16375c] hover:to-[#122a47] ${className}`}
    >
      <span className="flex items-center gap-1.5">
        <Icon size={14} className="text-[#C9D2DC]" /> {LABELS[partner.category] || "Demander un devis"}
      </span>
      <span className="block text-center text-[10px] font-semibold leading-tight text-[#9FB2C8]">
        {partner.logo_url && <img src={partner.logo_url} alt="" className="mr-1 inline-block h-4 w-4 rounded object-contain align-middle" />}
        Proposé par {partner.name} · <span className="whitespace-nowrap">partenaire de Pactly&nbsp;Car</span>
      </span>
    </a>
  );
}
